module.exports = __webpack_public_path__ + "img/stretch--genre1_title--sp.c7fa66d5.png";